import React from 'react';
import ItemDetailImage from '../ItemDetailImage';

export default class VendorItemDetail extends ItemDetailImage {

    constructor(props) {
        super(props);

        const {item} = this.props;

        this.property = item.SoldBy;

        if(!this.property) {
            return;
        }

        this.singleItemUrl = `/npcs/${this.property[0].Id}`;
        this.multipleItemUrl = `/npcs?itemKey=${item.ItemKey}`;

        const zone = this.property[0].Zone ? this.property[0].Zone.English : '';
        const description =this.property[0].SecondaryName ?  this.property[0].SecondaryName.English : '';

        this.singleItemContent = ( <div style={{marginTop: '7px'}}>{`<${description}>`}<br/><small>{zone}</small></div> );
        this.multipleItemContent = `This item is sold by ${this.property.length} different vendors`;

        this.header = this.property[0].PrimaryName.English;
    }

    get icon() {
        return 'coins';
    }
}


// WEBPACK FOOTER //
// ./src/items/index/item-detail-components/VendorItemDetail.jsx